import React, { useState, useEffect } from "react";

const OptionsModal = ({
  isOpen,
  onOpen,
  onClose,
  onSave,
  initialDepart,
  initialDifficulte,
  initialInvincible
}) => {

  const [depart, setDepart] = useState(1);
  const [difficulte, setDifficulte] = useState(1);
  const [invincible, setInvincible] = useState(false);

  const [scale, setScale] = useState(1);
  const [imgSize, setImgSize] = useState({ width: 320, height: 700 });

  useEffect(() => {
    if (isOpen) {
      onOpen?.()
      setDepart(initialDepart);
      setDifficulte(initialDifficulte);
      setInvincible(initialInvincible);
    }
  }, [isOpen, initialDepart, initialDifficulte, initialInvincible]);

  // 🔥 Dimensions image
  useEffect(() => {
    const img = new Image();
    img.src = "/textures/options.png";

    img.onload = () => {
      setImgSize({
        width: img.naturalWidth,
        height: img.naturalHeight
      });
    };
  }, []);

  // 🔥 Scale dynamique
  useEffect(() => {
    const updateScale = () => {
      const padding = 20;

      const scaleX = (window.innerWidth - padding) / imgSize.width;
      const scaleY = (window.innerHeight - padding) / imgSize.height;

      setScale(Math.min(scaleX, scaleY, 1));
    };

    updateScale();
    window.addEventListener("resize", updateScale);
    return () => window.removeEventListener("resize", updateScale);
  }, [imgSize]);

  if (!isOpen) return null;

  const handleSave = () => {
    onSave?.({ depart, difficulte, invincible });
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">

      {/* SCALE GLOBAL */}
      <div
        style={{
          transform: `scale(${scale})`,
          transformOrigin: "center"
        }}
      >
        {/* CONTENEUR */}
        <div
          className="relative"
          style={{
            width: imgSize.width,
            height: imgSize.height,
            backgroundImage: "url(/textures/options.png)",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat"
          }}
        >

          {/* CLOSE */}
          <button
            onClick={onClose}
            className="absolute text-white"
            style={{
              top: "2%",
              right: "3%",
              fontSize: `${imgSize.width * 0.06}px`
            }}
          >
            ×
          </button>

          {/* ===== DÉPART ===== */}
          <div
            className="absolute"
            style={{
              left: "9%",
              right: "9%",
              top: "52%",
              height: "5%"
            }}
          >
            <select
              value={depart}
              onChange={(e) => setDepart(Number(e.target.value))}
              className="w-full h-full bg-blue-900 text-white outline-none appearance-none"
              style={{
                fontSize: `${imgSize.width * 0.045}px`
              }}
            >
              <option value={1}>Gouin</option>
              <option value={2}>Henri-Bourassa</option>
              <option value={3}>Sauvé</option>
              <option value={4}>Crémazie</option>
              <option value={5}>Jarry</option>
              <option value={6}>Jean-Talon</option>
              <option value={7}>Beaubien</option>
              <option value={8}>Rosemont</option>
              <option value={9}>Laurier</option>
              <option value={10}>Mont-Royal</option>
              <option value={12}>Sherbrooke</option>
              <option value={13}>Berri</option>
              <option value={14}>De la Commune</option>
            </select>
          </div>

          {/* ===== DIFFICULTÉ ===== */}
          <div
            className="absolute"
            style={{
              left: "9%",
              right: "9%",
              top: "66.5%",
              height: "5%"
            }}
          >
            <select
              value={difficulte}
              onChange={(e) => setDifficulte(Number(e.target.value))}
              className="w-full h-full bg-blue-900 text-white outline-none appearance-none"
              style={{
                fontSize: `${imgSize.width * 0.045}px`
              }}
            >
              <option value={1}>Facile</option>
              <option value={2}>Normal</option>
              <option value={3}>Difficile</option>
            </select>
          </div>

          {/* ===== INVINCIBLE ===== */}
          <div
            className="absolute flex items-center justify-center cursor-pointer"
            onClick={() => setInvincible(!invincible)}
            style={{
              left: "87%",     // 🔥 position X corrigée
              top: "78%",    // 🔥 position Y corrigée
              width: "7%",   // 🔥 taille proportionnelle
              height: "4%",
              transform: "translate(-50%, -50%)"
            }}
          >
            {invincible && (
              <img
                src="/textures/check.png"
                alt="check"
                className="w-full h-full"
              />
            )}
          </div>

          {/* ===== SAVE ===== */}
          <div
            className="absolute"
            style={{
              bottom: "7%",
              left: "50%",
              transform: "translateX(-50%)",
              width: "55%",   
              height: "5%"    // 🔥 hauteur proportionnelle
            }}
          >
            <button
              onClick={handleSave}
              className="w-full h-full text-white flex items-center justify-center"
              style={{
                fontSize: `${imgSize.width * 0.05}px`,
                background: "rgba(37, 99, 235, 0.8)",
                borderRadius: `${imgSize.width * 0.03}px`
              }}
            >
              Enregistrer
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default OptionsModal;
